module.exports = __webpack_public_path__ + "static/media/orangedental.3618c8a6.jfif";